import axios from 'axios';

export default class MailService {

    constructor () {
        this.status = {};
        this.reset();
    }

    send (from, message) {
        Object.assign(this.status, { idle: null, loading: true, success: null, error: null });
        return axios
            .post('php/contact.php', { from, message })
            .then (
                resp => Object.assign(this.status, { idle: null, loading: null, success: true, error: null }),
                resp => Object.assign(this.status, { idle: null, loading: null, success: null, error: resp })
            );
    }

    reset () {
        Object.assign(this.status, { idle: true, loading: null, success: null, error: null });
    }
    
}